<script lang="ts" setup>
import { EvaluationCriteria, TokenData } from "types/EvaluationResults";

const props = defineProps({
  evaluationResults: {
    type: Object as PropType<EvaluationCriteria[]>,
    required: true,
  },
  tokenData: {
    type: Object as PropType<TokenData[]>,
    required: false,
  },
  showTokenData: {
    type: Boolean,
    default: false,
  },
  showHiddenCriteria: {
    type: Boolean,
    default: false,
  },
});

const filteredCriteria = computed(() => {
  return props.evaluationResults.filter((criteria) => {
    return criteria.config?.isMechanics != true;
  });
});
</script>

<template>
  <div class="flex flex-col">
    <DocumentProblemReviewTestingCriteriaItem
      v-for="(criteria, index) in filteredCriteria"
      :key="index"
      :criteria="criteria"
      :token-data="tokenData"
      :show-token-data="showTokenData"
      :show-hidden-criteria="showHiddenCriteria"
    />
  </div>
</template>

<style scoped></style>
